// ABOUTME: REST calls of the dealership module: the selectable dealerships and an offer's dealership stamp.
// ABOUTME: Both answer through the CPQ apiFetch helper, which throws an ApiError on `success: false`.

import { apiFetch } from '../../cpq/utils/apiFetch';
import type { SelectableDealerships } from '../types';

/** The dealerships the user may pick or assign (GET /api/cpq/dealerships). */
export const fetchSelectableDealerships = (): Promise<SelectableDealerships> =>
    apiFetch<SelectableDealerships>('/api/cpq/dealerships');

type OfferWithDealership = { offer?: { assignedDealership?: string | null } };

/** The offer's dealership stamp, or null when it has none. */
export const fetchOfferDealership = async (offerId: string): Promise<string | null> => {
    const detail = await apiFetch<OfferWithDealership>(
        `/api/cpq/offers/${encodeURIComponent(offerId)}`,
    );
    return detail.offer?.assignedDealership ?? null;
};
